import React from 'react'
import { Box, Flex, Tabs } from '@mantine/core'

import { StepsNavigation } from './StepsNavigation'

import { Details } from '@/components/Event/NewScript/components/common/Layout/Details'
import { useBreakpoints } from '@/hooks/useBreakpoints'
import { Event } from '@/types'

type ScriptLayoutProps = {
  event: Event
  showNavigation?: boolean
  children: React.ReactNode
}

export const ScriptLayout = ({
  event,
  showNavigation = true,
  children,
}: ScriptLayoutProps) => {
  const { lg, md, sm } = useBreakpoints()
  const isMidScreen = !lg && (md || sm)

  if (lg || isMidScreen) {
    return (
      <Flex
        gap="md"
        justify="space-between"
        align="flex-start"
        direction="row"
        wrap="nowrap"
        p="xl"
      >
        {!isMidScreen && (
          <Box>{showNavigation && <StepsNavigation event={event} />}</Box>
        )}
        <Box w={740}>
          {isMidScreen && showNavigation && (
            <StepsNavigation event={event} collapsed />
          )}
          {children}
        </Box>
        <Box w={280}>
          <Details event={event} />
        </Box>
      </Flex>
    )
  }

  return (
    <Tabs defaultValue="script">
      <Tabs.List position="center">
        <Tabs.Tab value="script">Script</Tabs.Tab>
        <Tabs.Tab value="details">Details</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="script" p="xl">
        {showNavigation && <StepsNavigation event={event} collapsed />}
        {children}
      </Tabs.Panel>

      <Tabs.Panel value="details" p="xl">
        <Details event={event} />
      </Tabs.Panel>
    </Tabs>
  )
}
